// extracted by css-extract-rspack-plugin
export default {"openLabel":"BqYs7mX2t3ca3Uee","staticLabel":"G0XTojIdpjMnYpfA","inputWrapper":"NnMR_sWR58xf6p0X"};